// Product list for the recommendation system
export const products = [
  {
    id: 1,
    name: "iPhone 14",
    price: 799,
    category: "Smartphone"
  },
  {
    id: 2,
    name: "Samsung Galaxy A54",
    price: 449,
    category: "Smartphone"
  },
  {
    id: 3,
    name: "Google Pixel 7",
    price: 599,
    category: "Smartphone"
  },
  {
    id: 4,
    name: "Sony WH-1000XM5",
    price: 399,
    category: "Headphones"
  },
  {
    id: 5,
    name: "Apple AirPods Pro",
    price: 249,
    category: "Headphones"
  },
  {
    id: 6,
    name: "iPad Air",
    price: 599,
    category: "Tablet"
  }
];
